const BASE_URL = 'https://kb2full5cg.execute-api.ap-south-1.amazonaws.com/dev';
const ID_TOKEN_KEY = 'id_token';

function getHeaders() {
  const token = localStorage.getItem(ID_TOKEN_KEY);

  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: token ? `Bearer ${token}` : ''
  };
}

async function makeRequest(endpoint, method = 'GET', params = {}, body = null) {
  const queryString =
    Object.keys(params).length > 0 ? `?${new URLSearchParams(params).toString()}` : '';
  const response = await fetch(`${BASE_URL}${endpoint}${queryString}`, {
    method,
    headers: getHeaders(),
    body: body && (method === 'POST' || method === 'PUT') ? JSON.stringify(body) : null
  });

  if (!response.ok) {
    const error = new Error(`API Error: ${response.status} ${response.statusText}`);
    error.status = response.status;
    throw error;
  }

  return response.json();
}

const apiService = {
  getAdminUsers() {
    return makeRequest('/admin-controls', 'GET', { req_type: 'users' });
  },

  getPendingAdminUsers() {
    return makeRequest('/admin-controls', 'GET', { req_type: 'pending_users' });
  },

  getAdminUserDetails(userEmail) {
    return makeRequest('/admin-controls', 'GET', {
      req_type: 'user_details',
      user_email: userEmail
    });
  },

  updateAdminUser(reqType, userEmail) {
    return makeRequest(
      '/admin-controls',
      'POST',
      { req_type: reqType },
      { user_email: userEmail }
    );
  },

  enableAdminUser(userEmail) {
    return this.updateAdminUser('enable', userEmail);
  },

  disableAdminUser(userEmail) {
    return this.updateAdminUser('disable', userEmail);
  },

  approveAdminUser(userEmail) {
    return this.updateAdminUser('approve', userEmail);
  },

  rejectAdminUser(userEmail) {
    return this.updateAdminUser('reject', userEmail);
  },

  forceLogoutAdminUser(userEmail) {
    return this.updateAdminUser('force_logout', userEmail);
  },

  resetAdminUserPassword(userEmail) {
    return this.updateAdminUser('reset_password', userEmail);
  },

  deleteAdminUser(userEmail) {
    return this.updateAdminUser('delete', userEmail);
  },

  getTokenValidation() {
    return makeRequest('/update-token', 'POST', { req_type: 'tokenValidation',token_type:'data' }, {});
  },

  updateRefreshToken(token, pin, appIDHash, clientID) {
    return makeRequest(
      '/update-token',
      'POST',
      { req_type: 'updateToken', token_type: 'data' },
      { token, pin, appIDHash, clientID }
    );
  }
};

export default apiService;
